import { DialogMode } from '@ori-events/open-product-info-dialog';

import type { SearchProduct } from '../components/SearchPreview/types';
import { openProductInfoDialog } from './openProductInfoDialog';
import { openShadePicker } from './openShadePicker';

export const getQuickBuyButtonOnClickHandler = (product: SearchProduct) => {
  if (product.hasAutosubscribe) {
    return openProductInfoDialog(DialogMode.StandardBuy, product.code);
  } else if (product.isMultishade) {
    return openShadePicker(product);
  }

  return undefined;
};
